export const TradeExecutionType = {
    Market: 'market',
    LimitFill: 'limitFill',
    LimitMatchRestingOrder: 'limitMatchRestingOrder',
    LimitMatchNewOrder: 'limitMatchNewOrder',
};
export const TradeExecutionSide = {
    Maker: 'maker',
    Taker: 'taker',
};
export const TradeDirection = {
    Buy: 'buy',
    Sell: 'sell',
    Long: 'long',
    Short: 'short',
};
export const OrderState = {
    Unfilled: 'unfilled',
    Booked: 'booked',
    PartialFilled: 'partial_filled',
    PartiallyFilled: 'partially_filled',
    Filled: 'filled',
    Canceled: 'canceled',
    Triggered: 'triggered',
};
export const OrderSide = {
    Unspecified: 'unspecified',
    Buy: 'buy',
    Sell: 'sell',
    StopBuy: 'stop_buy',
    StopSell: 'stop_sell',
    TakeBuy: 'take_buy',
    TakeSell: 'take_sell',
    BuyPO: 'buy_po',
    SellPO: 'sell_po',
    BuyAtomic: 'buy_atomic',
    SellAtomic: 'sell_atomic',
    Unrecognized: 'unrecognized',
};
